import React from 'react'

const KeystrokesAlertScreen = () => {
  return (
    <>
        <div className="d-flex align-items-center justify-content-end flex-wrap gap-3 mb-6">
            <select
                className="form-select content-200 text-dark"
                id="country"
                aria-label="Default select example"
                name="gender"
            >
                <option value="1">Today</option>
                <option value="2">1 Week</option>
            </select>
              <span className="icon-wrap pt-cursor bg-gray-300" >
                  <i className="icon-filter" />
              </span>
        </div>
        <p className='mb-6 text-dark fw-semibold'>13 Jul 2023 | 01:57 PM</p>
        <div className="alert alert-warning alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold" role="alert">
            <i className='icon-info-octagon fs-5' />
            Amina tried to access blocked website : noon.com
            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
        <div className="alert alert-warning alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold" role="alert">
            <i className='icon-info-octagon fs-5' />
            Amina tried to access blocked website : noon.com
            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
        <hr className='mb-6' />
        <p className='mb-6 text-dark fw-semibold'>12 Jul 2023 | 02:57 PM</p>
        <div className="alert alert-warning alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold" role="alert">
            <i className='icon-info-octagon fs-5' />
            Amina tried to access blocked website : noon.com
            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
    </>
  )
}

export default KeystrokesAlertScreen